import { Component, Input, OnInit } from '@angular/core';
import { HighlightNew } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-news-small',
  templateUrl: './sample-news-small.component.html',
  styleUrls: ['./sample-news-small.component.scss']
})
export class SampleNewsSmallComponent implements OnInit {

  @Input() dataNews: HighlightNew = {} as HighlightNew;
  @Input() isNews: boolean = false;
  public stringTaxonomies: string = '';
  public isLinkEsternal: boolean = false;
  public domainWebsite = environment.urlApi;
  public imgPath = '';
  public image_alt = '';
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };

  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (this.dataNews) {
      this.setVariable();
      this.setLabelTags();
    }
  }

  private setVariable() {
    this.objTitle = this.helperService.retriveLinkTagA(this.dataNews.field_titolo, "a");
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.dataNews.field_immagine, "src");
    this.image_alt = this.helperService.retrieveImage(this.dataNews.field_immagine, "alt");
    this.isLinkEsternal = this.objTitle ? this.helperService.verifyLinkExternal(this.objTitle.link) : false;
  }

  private setLabelTags() {
    let taxonomies: string[] = [];
    if (this.dataNews.field_tassonomia_area_universita) {
      this.dataNews.field_tassonomia_area_universita.forEach((taxonomy, idx) => {
        if (idx < 3) {
          taxonomies.push(taxonomy.name);
        }
      });
      if (this.dataNews.field_tassonomia_area_universita.length > 3) {
        taxonomies.push(`+${this.dataNews.field_tassonomia_area_universita.length - 3}`)
      }
    }
    this.stringTaxonomies = taxonomies.join(', ');
  }

}
